import { EventEmitter, Injectable } from "@angular/core";

import { AlternativeCrop } from "@models/AlternativeCrop";
import { AlternativeCropSearchCriteria } from "@models/AlternativeCropSearchCriteria";
import { SearchCriteria } from "@models/SearchCriteria";
import { TopLevelSearchResult } from "@models/TopLevelSearchResult";

@Injectable({ providedIn: "root" })
export class SearchService {
  startPage = 1;
  endPage = 5;

  searchResultsUpdated$ = new EventEmitter();
  alternativeCropSearchResultsUpdated$ = new EventEmitter();
  searchStatusUpdated$ = new EventEmitter<boolean>();

  resultHistory: TopLevelSearchResult[] = [];
  criteriaHistory: Map<string, SearchCriteria> = new Map<string, SearchCriteria>();
  searchTypeHistory: Map<string, string> = new Map<string, string>();

  private _result: TopLevelSearchResult;
  get result(): TopLevelSearchResult {
    return this._result;
  }
  set result(result: TopLevelSearchResult) {
    this._result = result;
    this.searchResultsUpdated$.emit();
  }

  searchCriteria: SearchCriteria;

  private _alternativeCropSearchResults: AlternativeCrop[] = [];
  get alternativeCropSearchResults(): AlternativeCrop[] {
    return this._alternativeCropSearchResults;
  }
  set alternativeCropSearchResults(alternativeCropSearchResults: AlternativeCrop[]) {
    this._alternativeCropSearchResults = alternativeCropSearchResults;

    this.alternativeCropSearchResultsUpdated$.emit();
  }

  alternativeCropSearchCriteria: AlternativeCropSearchCriteria;

  searchType: string;
  searchPage = 1;
  viewBy = "textList";

  updateSearchStatus(isSearching: boolean) {
    this.searchStatusUpdated$.emit(isSearching);
  }
}
